import PageHeader from '../../../components/PageHeader/PageHeader';
import ResourcesTable from './ResourcesTable';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';

export default function Resources() {
  
  const { t } = useTranslation();
  const { locationId } = useParams();
  
  const userPermissions = JSON.parse(localStorage.getItem('permissions')) || [];
  const hasPermission = (permissionId) => userPermissions.includes(permissionId);

  return (
    <Box p={3}>
        <PageHeader title={t('resources')} subtitle={t('manage_resources')} />
        <ResourcesTable locationId={locationId}/>
    </Box>
  );
}
